import { Screen } from '../api/types';
import ScreenButtonAriaLabelRenderer from './ScreenButtonAriaLabelRenderer';
import GeneralComponent from '../components/GeneralComponent';

function render(screen: Screen, screenButtonIsSectionHeadingOnly: boolean) {
  const screenButtonAriaLabelRenderer = new ScreenButtonAriaLabelRenderer(GeneralComponent.priceRangeSeparator);
  const { isAvailable, description } = screen;
  const disabledClass = isAvailable ? '' : 'disabled';
  const disabledAttr = isAvailable ? '' : 'aria-disabled="true"';

  let headingClass = 'tn-syos-screen-button__section-heading';

  if (screenButtonIsSectionHeadingOnly) {
    headingClass += ' tn-syos-screen-button__section-heading--standalone';
  }

  return `<li class="tn-syos-screen-container__button-list-item">
  <button class="tn-syos-screen-button btn btn-primary ${disabledClass}" ${disabledAttr} aria-label="${screenButtonAriaLabelRenderer.getAriaLabel(screen)}">
    <span class="h5 ${headingClass}">${description}</span>
    ${renderButtonBody(screen)}
 </button>
</li>`;
}

function renderButtonBody({
  isAvailable,
  priceTypeDescription,
  screenButtonShouldDisplayPriceTypeDescription,
  screenButtonShouldRenderPriceRange,
  minPriceDisplay,
  maxPriceDisplay,
}: Screen) {
  if (!isAvailable) {
    return `<span class="tn-syos-screen-button__message-unavailable">No Tickets Available</span>`;
  }

  const values = [];

  if (screenButtonShouldDisplayPriceTypeDescription) {
    let priceTypeLabelClass = 'tn-syos-screen-button__pricetype-label';

    if (!screenButtonShouldRenderPriceRange) {
      priceTypeLabelClass += ' tn-syos-screen-button__pricetype-label--without-price-range';
    }

    values.push(`<span class="${priceTypeLabelClass}">${priceTypeDescription}</span>`);
  }

  if (screenButtonShouldRenderPriceRange) {
    values.push(`<span class="tn-syos-screen-button__min-price">${minPriceDisplay}</span>`);

    if (minPriceDisplay !== maxPriceDisplay) {
      values.push('&nbsp;');
      values.push(`<span class="tn-syos-screen-button__separator">${GeneralComponent.priceRangeSeparator}</span>`);
      values.push('&nbsp;');
      values.push(`<span class="tn-syos-screen-button__max-price">${maxPriceDisplay}</span>`);
    }
  }

  return values.join('');
}

export default {
  render,
};
